import { createDecorator } from '../../instantiation/common/instantiation.js';
const ILanguagePackService = ( createDecorator('languagePackService'));
export { ILanguagePackService };
